import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';
import Routes from './Routes';

export const StaticPages = () => (
	<Switch>
		<Route path="/admin/static" exact component={List} />
		<Route path="/admin/static/create" component={Edit} />
		<Route path="/admin/static/routes" component={Routes} />
		<Route path="/admin/static/:id" component={Edit} />
	</Switch>
);
